const CELL_VALUE = (index: number, { _data: data }: any) => data[index];

export default CELL_VALUE;
